import {useMemo} from "react";
import {useSelector} from "react-redux";

import {IRPStore} from "../../../app/rp_reducer";
import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {usePropertyEstimatedPrice} from "../../../report/price/hooks/usePropertyEstimatedPrice";
import {InsightVariant} from "./InsightVariant";

export const useInsightVariant = (property: IPropertyDetail | undefined) => {
    const promotions = useSelector((store: IRPStore) => store.property.promotions);

    const {estimatedPriceData, apiFieldWithAvgPrice, isLoading: isPriceLoading} = usePropertyEstimatedPrice(property);

    const hasPropertyPromo = property?.is_promo;
    const hasOfferPromotions = promotions.length > 0;
    const hasAnyPromotion = hasPropertyPromo || hasOfferPromotions;

    const currentAvgPriceM2 = useMemo(() => {
        if (estimatedPriceData?.length && apiFieldWithAvgPrice) {
            return estimatedPriceData[estimatedPriceData.length - 1]?.[apiFieldWithAvgPrice] as number | undefined;
        }
        return undefined;
    }, [estimatedPriceData, apiFieldWithAvgPrice]);

    const variant = useMemo((): InsightVariant => {
        if (hasPropertyPromo) {
            return InsightVariant.HAS_PROPERTY_PROMOTION;
        }

        if (hasOfferPromotions) {
            return InsightVariant.HAS_OFFER_PROMOTIONS;
        }

        if (currentAvgPriceM2 && property?.price_m2 && property.price_m2 > 0) {
            const ratio = property.price_m2 / currentAvgPriceM2;

            if (ratio > 1.05) {
                return InsightVariant.PRICE_ABOVE_AVERAGE;
            }

            if (ratio < 0.95) {
                return InsightVariant.PRICE_BELOW_AVERAGE;
            }

            return InsightVariant.PRICE_OPTIMAL;
        }

        return InsightVariant.NONE;
    }, [hasPropertyPromo, hasOfferPromotions, currentAvgPriceM2, property?.price_m2]);

    const percentageBelow = useMemo(() => {
        if (variant === InsightVariant.PRICE_BELOW_AVERAGE && currentAvgPriceM2 && property?.price_m2) {
            return Math.round(((currentAvgPriceM2 - property.price_m2) / currentAvgPriceM2) * 100);
        }

        return null;
    }, [variant, currentAvgPriceM2, property?.price_m2]);

    const isLoading = !property || (!hasAnyPromotion && isPriceLoading);

    return {
        variant,
        buttonText: variantButtonText[variant],
        isLoading,
        percentageBelow,
        promotionExample: promotions?.map((promotion) => promotion.name).join(", ") ?? null
    };
};

const variantButtonText: Record<InsightVariant, string> = {
    [InsightVariant.NONE]: "Zapytaj o ofertę",
    [InsightVariant.PRICE_ABOVE_AVERAGE]: "Zapytaj o rabat",
    [InsightVariant.HAS_OFFER_PROMOTIONS]: "Zapytaj o promocję",
    [InsightVariant.HAS_PROPERTY_PROMOTION]: "Zapytaj o ofertę z promocją",
    [InsightVariant.PRICE_OPTIMAL]: "Zapytaj o ofertę",
    [InsightVariant.PRICE_BELOW_AVERAGE]: "Zapytaj o dostępność"
};
import {useMemo} from "react";
import {useSelector} from "react-redux";

import {IRPStore} from "../../../app/rp_reducer";
import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {usePropertyEstimatedPrice} from "../../../report/price/hooks/usePropertyEstimatedPrice";
import {InsightVariant} from "./InsightVariant";

export const useInsightVariant = (property: IPropertyDetail | undefined) => {
    const promotions = useSelector((store: IRPStore) => store.property.promotions);

    const {estimatedPriceData, apiFieldWithAvgPrice, isLoading: isPriceLoading} = usePropertyEstimatedPrice(property);

    const hasPropertyPromo = property?.is_promo;
    const hasOfferPromotions = promotions.length > 0;
    const hasAnyPromotion = hasPropertyPromo || hasOfferPromotions;

    const currentAvgPriceM2 = useMemo(() => {
        if (estimatedPriceData?.length && apiFieldWithAvgPrice) {
            return estimatedPriceData[estimatedPriceData.length - 1]?.[apiFieldWithAvgPrice] as number | undefined;
        }
        return undefined;
    }, [estimatedPriceData, apiFieldWithAvgPrice]);

    const variant = useMemo((): InsightVariant => {
        if (hasPropertyPromo) {
            return InsightVariant.HAS_PROPERTY_PROMOTION;
        }

        if (hasOfferPromotions) {
            return InsightVariant.HAS_OFFER_PROMOTIONS;
        }

        if (currentAvgPriceM2 && property?.price_m2 && property.price_m2 > 0) {
            const ratio = property.price_m2 / currentAvgPriceM2;

            if (ratio > 1.05) {
                return InsightVariant.PRICE_ABOVE_AVERAGE;
            }

            if (ratio < 0.95) {
                return InsightVariant.PRICE_BELOW_AVERAGE;
            }

            return InsightVariant.PRICE_OPTIMAL;
        }

        return InsightVariant.NONE;
    }, [hasPropertyPromo, hasOfferPromotions, currentAvgPriceM2, property?.price_m2]);

    const percentageBelow = useMemo(() => {
        if (variant === InsightVariant.PRICE_BELOW_AVERAGE && currentAvgPriceM2 && property?.price_m2) {
            return Math.round(((currentAvgPriceM2 - property.price_m2) / currentAvgPriceM2) * 100);
        }

        return null;
    }, [variant, currentAvgPriceM2, property?.price_m2]);

    const isLoading = !property || (!hasAnyPromotion && isPriceLoading);

    return {
        variant,
        buttonText: variantButtonText[variant],
        isLoading,
        percentageBelow,
        promotionExample: promotions?.map((promotion) => promotion.name).join(", ") ?? null
    };
};

const variantButtonText: Record<InsightVariant, string> = {
    [InsightVariant.NONE]: "Zapytaj o ofertę",
    [InsightVariant.PRICE_ABOVE_AVERAGE]: "Zapytaj o rabat",
    [InsightVariant.HAS_OFFER_PROMOTIONS]: "Zapytaj o promocję",
    [InsightVariant.HAS_PROPERTY_PROMOTION]: "Zapytaj o ofertę z promocją",
    [InsightVariant.PRICE_OPTIMAL]: "Zapytaj o ofertę",
    [InsightVariant.PRICE_BELOW_AVERAGE]: "Zapytaj o dostępność"
};
